module.exports = __webpack_public_path__ + "static/sedi-b7c4c3c6bfce3d10b586e8e70e5be855.png";